import { request } from '../../helpers/apiHelper'
import { displayNotification } from '../../actions/notificationsActions'
import {
  adminQuery,
  adminsQuery,
  adminsListQuery,
  createAdminMutation,
  updateAdminBadgesMutation,
} from './queries'
import { User } from '../../core/types'

export const fetchAdmin = (id) => (dispatch) => {
  return request(adminQuery, { id })
    .then((response) => {
      dispatch({
        type: 'FETCH_ADMINUSER_SUCCESS',
        entity: response.data.data.user,
      })
    })
    .catch(() => {
      dispatch({
        type: 'FETCH_ADMINUSER_FAILURE',
      })
      dispatch(displayNotification('Failed to fetch Admin', 'error'))
    })
}

export const fetchAdminList = (badges) => (dispatch) => {
  return request(adminsListQuery, { badges })
    .then((response) => {
      dispatch({
        type: 'FETCH_ADMINUSERS_SUCCESS',
        entities: response.data.data.users.items,
        meta: response.data.data.users.meta,
      })
    })
    .catch(() => {
      dispatch({
        type: 'FETCH_ADMINUSERS_FAILURE',
      })
      dispatch(displayNotification('Failed to fetch Admins', 'error', 10000))
    })
}

export const fetchAdminIndex = (varObject) => (dispatch) => {
  return request(adminsQuery.toString(), varObject)
    .then((response) => {
      dispatch({
        type: 'FETCH_ADMINUSERS_SUCCESS',
        entities: response.data.data.users.items,
        meta: response.data.data.users.meta,
      })
    })
    .catch(() => {
      dispatch({
        type: 'FETCH_ADMINUSERS_FAILURE',
      })
      dispatch(displayNotification('Failed to fetch Admins', 'error', 10000))
    })
}

type CreateAdminPayload = Partial<User>

export const createAdmin = (user: CreateAdminPayload = {}) => (dispatch) => {
  return request(createAdminMutation.toString(), { user })
    .then((response) => {
      if (response.data.errors) {
        throw new Error(response.data.errors[0].message)
      } else {
        const user = response.data.data.createUser.user
        dispatch({
          type: 'CREATE_ADMINUSER_SUCCESS',
          entity: user,
        })
        return user.id
      }
    })
    .catch((error) => {
      dispatch({ type: 'CREATE_ADMINUSER_FAILURE' })
      dispatch(
        displayNotification(`Failed create admin: ${error.message}`, 'error')
      )
      throw new Error(error)
    })
}

export const updateAdminBadges = (
  id,
  badges,
  successMessage: (admin: { name: string }) => string = (admin) =>
    `Update badges for: ${admin.name}`
) => (dispatch) => {
  return request(updateAdminBadgesMutation, { id, badges })
    .then((response) => {
      if (response.data.errors) {
        throw new Error(response.data.errors[0].message)
      } else {
        const admin = response.data.data.updateUserBadges.user
        dispatch({
          type: 'UPDATE_ADMINUSER_SUCCESS',
          entity: admin,
        })
        dispatch(
          displayNotification(successMessage(admin), 'success', 10000)
        )
      }
    })
    .catch((error) => {
      dispatch({ type: 'UPDATE_ADMINUSER_FAILURE' })
      dispatch(
        displayNotification(
          `Failed to update badges: ${error.message}`,
          'error'
        )
      )
      throw new Error(error)
    })
}
